<mat-nav-list class="pt-0">
	<a mat-list-item *ngIf="accountAttributesEnum.SALESFORCE | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onSalesforceSettings()" tabindex="">
		Salesforce Settings
	</a>
	<a mat-list-item *ngIf="accountAttributesEnum.HUBSPOT | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onHubspotSettings()" tabindex="">
		Hubspot Settings
	</a>
	<a mat-list-item *ngIf="accountAttributesEnum.MARKETO | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onMarketoSettings()" tabindex="">
		Marketo Settings
	</a>
	<a mat-list-item *ngIf="accountAttributesEnum.OUTREACH | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onOutreachSettings()" tabindex="">
		Outreach Settings
	</a>
	<a mat-list-item *ngIf="accountAttributesEnum.SALESLOFT | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onSalesloftSettings()" tabindex="">
		SalesLoft Settings
	</a>
	<a mat-list-item *ngIf="accountAttributesEnum.DYNAMICS | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onDynamicsSettings()" tabindex="">
		Dynamics 365 Settings
	</a>
	<a mat-list-item *ngIf="accountAttributesEnum.ZOHO | hasAccessAsync | async" class="pl-4" [ngClass]="{ 'disabled': isIntegrationSettingsOpened }" (click)="onZohoSettings()" tabindex="">
		Zoho Settings
	</a>
</mat-nav-list>
